import { render, staticRenderFns } from "./StatusPageWidget.vue?vue&type=template&id=5d1e0b2e&"
import script from "./StatusPageWidget.vue?vue&type=script&lang=js&"
export * from "./StatusPageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports